import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { advancedOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { MergeRpmCustomerRecord } from '../Tabs/CustomerMap/CustomerMergeList';
import { RecordLink } from '../../../Atoms/RecordLink';

export const DefaultCustomerMergeListGridColumnDefs: GridSingleSelectColDef[] = [
  {
    headerName: 'Merge RPM Customer',
    field: 'mergeCustomerName',
    flex: 3,
    minWidth: 240,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<MergeRpmCustomerRecord>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Customer.aspx?Item=${params.row.mergeCustomerId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.mergeCustomerName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'Merge RPM Customer ID',
    field: 'mergeCustomerId',
    flex: 1,
    minWidth: 170,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators()
  },
  {
    headerName: 'Master RPM Customer',
    field: 'masterCustomerName',
    flex: 3,
    minWidth: 240,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<MergeRpmCustomerRecord>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Customer.aspx?Item=${params.row.masterCustomerId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.masterCustomerName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'Master RPM Customer ID',
    field: 'masterCustomerId',
    flex: 1,
    minWidth: 170,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators()
  },
  {
    headerName: 'Salesforce Customer',
    field: 'sfdcCustomerName',
    flex: 3,
    minWidth: 200,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<MergeRpmCustomerRecord>) => (
      <RecordLink to={`/customer/${params.row.sfdcCustomerId}`}>
        <div className="flex items-center text-small">{params.row.sfdcCustomerName}</div>
      </RecordLink>
    )
  },
  {
    headerName: 'Salesforce Customer UID',
    field: 'sfdcCustomerId',
    flex: 1,
    minWidth: 170,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators()
  }
];
